import React, { useEffect, useState } from "react";
import { GeneralDetail, Edit } from "../../assets/svg";
import EditCompanyModal from "../companies/modal/EditCompanyModal";
import { useDispatch, useSelector } from "react-redux";
import { AddPrimaryButton } from "../../components/micro/input";
import { getGeneralSettingList } from "../../redux/masterSetting/slice";
import RippleLoader from "../../components/loader/RippleLoader";

const GeneralSetting = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isType, setIsType] = useState("");
  const [selectedData, setSelectedData] = useState(null);

  // Selector
  const { generalSettingData, loading } = useSelector((store) => ({
    generalSettingData:
      store?.settingData?.getGeneralSettingListStatus?.data?.data,
    loading: store?.settingData?.loading,
  }));

  useEffect(() => {
    dispatch(getGeneralSettingList());
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedData(null);
  };

  return (
    <>
      {loading ? (
        <RippleLoader />
      ) : (
        <div className="w-full bg-bgWhite shadow drop-shadow-md rounded-lg mt-3">
          {generalSettingData?.data.map((item, index) => (
            <div>
              <div className="flex items-center justify-between bg-background_grey py-5 px-6 border-b border-b-Grey">
                <h2 className="flex items-center gap-2 text-xl font-medium text-mgrey font-Montserrat">
                  <GeneralDetail />
                  <span className="font-Montserrat">Company Details</span>
                </h2>
                {Object.keys(item).length > 0 ? (
                  <button
                    className="cursor-pointer"
                    onClick={() => {
                      setIsModalOpen(true);
                      setIsType("edit");
                      setSelectedData(item);
                    }}
                  >
                    <Edit />
                  </button>
                ) : (
                  <AddPrimaryButton
                    value="ADD"
                    onClick={() => {
                      setIsModalOpen(true);
                      setIsType("add");
                      setSelectedData(null);
                    }}
                  />
                )}
              </div>
              <div className="py-5 px-6 grid grid-cols-2 gap-y-4">
                <div className="space-y-1">
                  <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                    Company Name:
                  </p>
                  <p className="text-sm font-normal text-mgrey font-Proxima">
                    {item?.company_name || "-"}
                  </p>
                </div>
                <div className="space-y-1">
                  <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                    UEN:
                  </p>
                  <p className="text-sm font-normal text-mgrey font-Proxima">
                    {item?.uen || "-"}
                  </p>
                </div>
                <div className="space-y-1">
                  <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                    Mobile Number:
                  </p>
                  <p className="text-sm font-normal text-mgrey font-Proxima">
                    {item?.mobile || "-"}
                  </p>
                </div>
                <div className="space-y-1">
                  <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                    Email:
                  </p>
                  <p className="text-sm font-normal text-mgrey font-Proxima">
                    {item?.email || "-"}
                  </p>
                </div>
                <div className="col-span-2 space-y-1 w-40">
                  <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                    Address:
                  </p>
                  <div className="text-sm font-normal text-mgrey font-Proxima">
                    <p className="text-sm font-normal text-mgrey font-Proxima">
                      {item?.address || "-"} , {item?.postal_code || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {isModalOpen && (
        <EditCompanyModal
          onClose={closeModal}
          generalSettingData={generalSettingData}
          isType={isType}
          selectedData={selectedData}
          modalType="generalSetting"
        />
      )}
    </>
  );
};

export default GeneralSetting;
